import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcLinkIcon } from '@gem/icons';

import { LinkRenderer } from 'APP/components/TextRenderer/renderTree/LinkRenderer/LinkRenderer';

import styles from './LinkItem.m.css';
import { ILinkItemProps, useLinkItemPresenter } from './LinkItem.presenter';

export const LinkItem: FC<ILinkItemProps> = observer(({ payload, links }) => {
  const presenter = useLinkItemPresenter({ payload, links });

  return (
    <div className={styles.container}>
      {presenter.link.imageUrl ? (
        <div className={styles.previewImage}>
          <LinkRenderer options={{ link: presenter.link.links[0] }}>
            {
              <img
                className={styles.image}
                src={presenter.link.imageUrl}
                alt=""
              />
            }
          </LinkRenderer>
        </div>
      ) : (
        <div className={styles.previewImage}>
          <IcLinkIcon className={styles.icon} />
        </div>
      )}
      <div className={styles.info}>
        <h6 className={styles.title}>{presenter.link.title}</h6>
        {presenter.link.description && (
          <p className={styles.description}>{presenter.link.description}</p>
        )}
        <ul className={styles.list}>
          {presenter.link.links.map((link) => (
            <li
              key={link}
              className={styles.listItem}
            >
              <LinkRenderer options={{ link: link }}>{link}</LinkRenderer>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
});
